import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Empty } from "antd";
import { NotificationManager } from "react-notifications";
import KycOrdersTab from "./KycOrdersTab";
import { fetchOrderMasterList } from "./kycOrderShared";

const KycPartnerOrdersTab = ({
	crmGuid,
	customer = "",
	search = "",
	isActive,
	navigationContext = {},
	tableSearchTerm = "",
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [ordersTable, setOrdersTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [ordersSorter, setOrdersSorter] = useState({
		field: "createdOn",
		order: "DESC",
	});

	const loadOrdersList = useCallback(async () => {
		if (!crmGuid || !customer) {
			setOrdersTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
			return;
		}

		setIsLoading(true);
		try {
			const result = await fetchOrderMasterList({
				customer,
				crmGuid,
				search,
				pageindex: ordersTable.currentPage,
				pagesize: ordersTable.pageSize,
				sortcolumn: ordersSorter.field,
				orderBy: ordersSorter.order,
				groupCompanyId: navigationContext.groupCompanyId || "",
			});

			setOrdersTable((prev) => ({
				...prev,
				rows: result.rows,
				totalRecords: result.totalRecords,
				currentPage: result.currentPage,
			}));
		} catch (error) {
			console.log(error, "Error");
			NotificationManager.error("Unable to load orders listing.");
			setOrdersTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
		} finally {
			setIsLoading(false);
		}
	}, [
		crmGuid,
		customer,
		search,
		ordersTable.currentPage,
		ordersTable.pageSize,
		ordersSorter.field,
		ordersSorter.order,
		navigationContext.groupCompanyId,
	]);

	useEffect(() => {
		if (!isActive || !crmGuid) {
			return undefined;
		}
		loadOrdersList();
		return undefined;
	}, [isActive, crmGuid, loadOrdersList]);

	useEffect(() => {
		if (!isActive) {
			return undefined;
		}
		setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
		return undefined;
	}, [search, isActive]);

	const handleOrdersTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setOrdersTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setOrdersSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const emptyText = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data found" />;

	const partnerDetailsContext = useMemo(
		() => ({
			crmGuid,
			customer,
			groupCompanyId: navigationContext.groupCompanyId || "",
			groupCompanyName: navigationContext.groupCompanyName || "",
			accountName: navigationContext.accountName || "",
			materialsCustomer: navigationContext.materialsCustomer || "",
			returnTab: navigationContext.returnTab || "account",
		}),
		[crmGuid, customer, navigationContext]
	);

	return (
		<KycOrdersTab
			tabTableData={ordersTable}
			isLoading={isLoading}
			tableSorter={ordersSorter}
			OnhandleTableSortColumn={handleOrdersTableChange}
			partnerDetailsContext={partnerDetailsContext}
			emptyText={emptyText}
			tableSearchTerm={tableSearchTerm}
		/>
	);
};

export default KycPartnerOrdersTab;
